<div class="container-fluid">
    <div class="row">
        <div class="col-2"><a class="carousel-control-prev arrowControl" (click)="prevArticle()" style="width:100%">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous
                </span></a></div>
        <div class="col-8">
            <div class="newsStage" style="width: 98%; position: relative; margin-left: auto; margin-right: auto;">
                <div class="row" style="position: relative; overflow: hidden; width: 100%;">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 newsArticle" *ngFor="let article of news_pool"
                        [ngClass]="article.isActive ? 'active' : ''" angulartics2On="click"
                        angularticsAction="ClickedNews" angularticsValue="{{article.title}}"
                        style="vertical-align: top;">
                        <h3 class="truncate" style="color: #ffffff">{{article.title}}</h3><br />
                        <p>{{article.shortDescription}}</p>
                        <div *ngIf="!article.isExternal"><a class="btn btn-outline-light"
                                routerLink="/news/{{ article.url }}">LEARN MORE</a></div>
                        <div *ngIf="article.isExternal"><a class="btn btn-outline-light" href="{{ article.link }}"
                                target="_blank">LEARN MORE</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-2"><a class="carousel-control-next arrowControl" (click)="nextArticle()"
                style="width:100%"><span class="carousel-control-next-icon" aria-hidden="true"></span><span
                    class="sr-only">Next </span></a></div>
    </div>
</div>